<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <h1>Companies</h1>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-btn
          depressed
          rounded
          large
          color="primary"
          @click.stop="showDialog = true"
        >
          Add company
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title>
            <v-col sm="6" offset-sm="6" cols="12">
              <v-text-field
                v-model="search"
                :append-icon="icons.mdiMagnify"
                label="Search"
                single-line
                hide-details
              />
            </v-col>
          </v-card-title>
          <v-data-table
            class="admin-list-table"
            :headers="headers"
            :items="companies"
            :search="search"
            :loading="loading"
            sort-by="tradingName"
            @click:row="redirectToCompany"
          />
        </v-card>
      </v-col>
    </v-row>

    <CompanyDialog v-model="showDialog" />
  </v-container>
</template>

<script>
  import { COMPANIES_QUERY } from '../../../constants/graphql/companies';
  import CompanyDialog from './CompanyDialog.vue';

  export default {
    name: 'CompaniesPage',
    components: {
      CompanyDialog,
    },
    data() {
      return {
        search: '',
        companies: [],
        loading: true,
        headers: [
          { text: 'Trading name', value: 'tradingName' },
          { text: 'Advisors', value: 'numberOfAdvisors' },
          { text: 'Company admins', value: 'numberOfCompanyAdmins' },
          {
            text: 'Fiduciary consultants',
            value: 'numberOfFiduciaryConsultants',
          },
          { text: 'Testators', value: 'numberOfTestators' },
          { text: 'Wills', value: 'numberOfCompletedWills' },
          { text: 'Commission', value: 'commission' },
        ],
        showDialog: false,
      };
    },
    methods: {
      redirectToCompany(item) {
        this.$router.push({ name: 'CompanyPage', params: { id: item.id } });
      },
    },
    apollo: {
      companies: {
        query: COMPANIES_QUERY,
        fetchPolicy: 'cache-and-network',
        result(response) {
          if (response.data) this.loading = false;
        },
      },
    },
  };
</script>
